(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["m2u-product-comparison"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('m2u-compare-guide')) return;

  let instanceCount = 0;

  class M2uCompareGuide extends HTMLElement {
    connectedCallback() {
      if (this._mounted) return;
      this._mounted = true;
      this._listeners = [];
      this._states = [];
      this._tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this._panels = Array.from(this.querySelectorAll('[data-panel]'));
      this._instanceId = this.id || `m2u-guide-${++instanceCount}`;
      this._mobile = window.matchMedia('(max-width: 899px)');
      this._reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (this._tabs.length && this._panels.length) this._setupTabs();

      this._panels.forEach((panel) => {
        const scroller = panel.querySelector('[data-carousel]');
        if (!scroller) return;
        const state = {
          panel,
          scroller,
          cards: Array.from(scroller.querySelectorAll('[data-card]')),
          previous: panel.querySelector('[data-prev]'),
          next: panel.querySelector('[data-next]'),
          position: panel.querySelector('[data-position]'),
          drag: null,
          frame: null,
          suppressClickUntil: 0
        };
        this._states.push(state);
        if (!scroller.hasAttribute('tabindex')) scroller.setAttribute('tabindex', '0');
        this._listen(scroller, 'pointerdown', (event) => this._startDrag(state, event));
        this._listen(scroller, 'pointermove', (event) => this._moveDrag(state, event));
        this._listen(scroller, 'pointerup', (event) => this._finishDrag(state, event, false));
        this._listen(scroller, 'pointercancel', (event) => this._finishDrag(state, event, true));
        this._listen(scroller, 'lostpointercapture', (event) => {
          if (event.target === scroller) this._finishDrag(state, event, true);
        });
        this._listen(scroller, 'click', (event) => {
          if (state.suppressClickUntil > Date.now() && event.detail !== 0) {
            event.preventDefault();
            event.stopPropagation();
          }
          state.suppressClickUntil = 0;
        }, true);
        this._listen(scroller, 'scroll', () => this._scheduleUpdate(state), { passive: true });
        this._listen(scroller, 'keydown', (event) => {
          if (event.target !== scroller || event.altKey || event.ctrlKey || event.metaKey) return;
          const index = this._currentIndex(state);
          const targets = { ArrowLeft: index - 1, ArrowRight: index + 1, Home: 0, End: state.cards.length - 1 };
          if (!(event.key in targets) || this._maxScroll(state) <= 1) return;
          event.preventDefault();
          this._goTo(state, targets[event.key]);
        });
        if (state.previous) this._listen(state.previous, 'click', () => this._goTo(state, this._currentIndex(state) - 1));
        if (state.next) this._listen(state.next, 'click', () => this._goTo(state, this._currentIndex(state) + 1));
      });

      this._listen(window, 'resize', () => {
        this._states.forEach((state) => {
          if (state.drag) this._cancelDrag(state);
          this._scheduleUpdate(state);
        });
      }, { passive: true });
      if (window.ResizeObserver) {
        this._observer = new ResizeObserver(() => this._states.forEach((state) => this._scheduleUpdate(state)));
        this._states.forEach((state) => this._observer.observe(state.scroller));
      }
      this.classList.add('is-enhanced');
      this._states.forEach((state) => this._update(state));
    }

    disconnectedCallback() {
      if (!this._mounted) return;
      this._mounted = false;
      this._states.forEach((state) => {
        this._cancelDrag(state);
        if (state.frame !== null) cancelAnimationFrame(state.frame);
      });
      this._listeners.forEach(([target, type, listener, options]) => target.removeEventListener(type, listener, options));
      if (this._observer) this._observer.disconnect();
      this._observer = null;
      this._listeners = [];
      this.classList.remove('is-enhanced');
      this._panels.forEach((panel) => { panel.hidden = false; });
    }

    _listen(target, type, listener, options) {
      target.addEventListener(type, listener, options);
      this._listeners.push([target, type, listener, options]);
    }

    _setupTabs() {
      const tablist = this._tabs[0].parentElement;
      if (tablist && this._tabs.every((tab) => tab.parentElement === tablist)) tablist.setAttribute('role', 'tablist');
      this._tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        if (!tab.id) tab.id = `${this._instanceId}-tab-${index + 1}`;
        const panel = this._panelFor(tab);
        if (panel) {
          if (!panel.id) panel.id = `${this._instanceId}-panel-${index + 1}`;
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
        }
        this._listen(tab, 'click', () => this._activateTab(index, false));
        this._listen(tab, 'keydown', (event) => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this._tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this._tabs.length) % this._tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this._tabs.length - 1;
          else return;
          event.preventDefault();
          this._activateTab(next, true);
        });
      });
      const selected = this._tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
      this._activateTab(selected < 0 ? 0 : selected, false);
    }

    _panelFor(tab) {
      return this._panels.find((panel) => panel.getAttribute('data-panel') === tab.getAttribute('data-tab'));
    }

    _activateTab(index, focus) {
      const selected = this._tabs[index];
      if (!selected) return;
      this._states.forEach((state) => this._cancelDrag(state));
      this._tabs.forEach((tab) => {
        const active = tab === selected;
        tab.setAttribute('aria-selected', String(active));
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      const activePanel = this._panelFor(selected);
      this._panels.forEach((panel) => { panel.hidden = panel !== activePanel; });
      if (focus) selected.focus();
      this._states.forEach((state) => this._scheduleUpdate(state));
    }

    _maxScroll(state) {
      return Math.max(0, state.scroller.scrollWidth - state.scroller.clientWidth);
    }

    _positions(state) {
      const left = state.scroller.getBoundingClientRect().left + state.scroller.clientLeft;
      return state.cards.map((card) => card.getBoundingClientRect().left - left + state.scroller.scrollLeft);
    }

    _currentIndex(state) {
      if (!state.cards.length || this._maxScroll(state) <= 1) return 0;
      const current = Math.max(0, state.scroller.scrollLeft);
      if (current >= this._maxScroll(state) - 1) return state.cards.length - 1;
      const positions = this._positions(state);
      return positions.reduce((closest, position, index) => Math.abs(position - current) < Math.abs(positions[closest] - current) ? index : closest, 0);
    }

    _goTo(state, index, immediate = false) {
      if (!state.cards.length) return;
      const target = Math.max(0, Math.min(state.cards.length - 1, index));
      const left = Math.max(0, Math.min(this._maxScroll(state), this._positions(state)[target]));
      state.scroller.scrollTo({ left, behavior: immediate || this._reducedMotion.matches ? 'auto' : 'smooth' });
      this._scheduleUpdate(state);
    }

    _startDrag(state, event) {
      if (!this._mobile.matches || this._maxScroll(state) <= 1 || !['touch', 'pen'].includes(event.pointerType)) return;
      if (event.isPrimary === false || state.drag) {
        this._cancelDrag(state);
        return;
      }
      state.suppressClickUntil = 0;
      state.drag = { pointerId: event.pointerId, x: event.clientX, y: event.clientY, lastX: event.clientX, scroll: state.scroller.scrollLeft, index: this._currentIndex(state), axis: null };
    }

    _moveDrag(state, event) {
      const drag = state.drag;
      if (!drag || drag.pointerId !== event.pointerId) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      drag.lastX = event.clientX;
      if (!drag.axis) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        drag.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (drag.axis === 'x') {
          state.scroller.classList.add('is-dragging');
          try { state.scroller.setPointerCapture(event.pointerId); } catch (_) {}
        }
      }
      if (drag.axis !== 'x') return;
      if (event.cancelable) event.preventDefault();
      state.scroller.scrollLeft = Math.max(0, Math.min(this._maxScroll(state), drag.scroll - dx));
      this._scheduleUpdate(state);
    }

    _finishDrag(state, event, canceled) {
      const drag = state.drag;
      if (!drag || drag.pointerId !== event.pointerId) return;
      const horizontal = drag.axis === 'x';
      const distance = drag.lastX - drag.x;
      let target = this._currentIndex(state);
      if (horizontal && !canceled && Math.abs(distance) >= 40 && target === drag.index) target += distance < 0 ? 1 : -1;
      this._cancelDrag(state);
      if (!horizontal) return;
      state.suppressClickUntil = Date.now() + 500;
      this._goTo(state, target, canceled);
    }

    _cancelDrag(state) {
      const drag = state.drag;
      state.drag = null;
      state.scroller.classList.remove('is-dragging');
      if (drag) {
        try {
          if (state.scroller.hasPointerCapture(drag.pointerId)) state.scroller.releasePointerCapture(drag.pointerId);
        } catch (_) {}
      }
    }

    _scheduleUpdate(state) {
      if (!this._mounted || state.frame !== null) return;
      state.frame = requestAnimationFrame(() => {
        state.frame = null;
        if (this._mounted) this._update(state);
      });
    }

    _update(state) {
      const maximum = this._maxScroll(state);
      const current = Math.max(0, state.scroller.scrollLeft);
      if (state.previous) state.previous.disabled = maximum <= 1 || current <= 1;
      if (state.next) state.next.disabled = maximum <= 1 || current >= maximum - 1;
      if (state.position) {
        const template = state.position.getAttribute('data-position-template') || '__CURRENT__ of __TOTAL__';
        state.position.textContent = template.replace(/__CURRENT__|\{\{\s*current\s*\}\}/g, String(state.cards.length ? this._currentIndex(state) + 1 : 0)).replace(/__TOTAL__|\{\{\s*total\s*\}\}/g, String(state.cards.length));
      }
    }
  }

  customElements.define('m2u-compare-guide', M2uCompareGuide);
})();


  } catch(e) { console.error(e); }
})();
})();
